export default __webpack_public_path__ + "static/media/GF_Main-Poster_Horizontal.e61b3959.jpg";